import { ChartColors } from 'constants/colors';

export const InvestmentTypeColors = {
  company: ChartColors[0],
  fund: ChartColors[1],
  listedCompany: ChartColors[2],
  realEstate: ChartColors[3],
  crypto: ChartColors[4],
  other: ChartColors[5],
};
